import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Number$isFinite from "@babel/runtime-corejs3/core-js/number/is-finite";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { reactive, computed, defineComponent, ref, onMounted, onUnmounted } from "@vue/composition-api";
import * as FieldComponents from "@Shared/components/sections/index";
import { formatIntegerQuantity, formatMoneyValueLong } from "@Shared/@Utils/helpers/money";
import MortgageCalculatorsToolbar from "./mortgage-calculators-toolbar.vue";
import ReportTabLayout from "@Broker/@Modules/clients/reports/reports-containers/report-tab-layout.vue";
import i18n from "@Shared/i18n";
import { showToast } from "@Shared/@Utils/constants";
const componentName = "RentBuyAnalyzerContainer";
export default defineComponent({
  name: componentName,
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    ReportTabLayout,
    MortgageCalculatorsToolbar
  }),
  setup() {
    const handleClearSelection = () => {
      indata.monthlyPayIfBought = 0;
      indata.propertytax = 0;
      indata.interestrate = 0.001;
      indata.monthlyRent = 0;
      indata.downpayment = 0;
      indata.annualIncreaseInHomePerc = 0;
      indata.yearsOfComparison = 5;
      return indata;
    };
    function isValidItem(val, min, max, formater) {
      min = Number(min);
      max = Number(max);
      if (val >= min && val <= max) return "";
      return i18n.t("financial-tools.message_missing_questionRange") + formater(min) + ", " + formater(max) + "]";
    }
    function formatVal(val) {
      return val.toLocaleString();
    }
    const rentBuyAnalyzerString = localStorage.getItem(componentName);
    const rentBuyAnalyzerData = rentBuyAnalyzerString ? JSON.parse(rentBuyAnalyzerString) : {};
    const indata = reactive({
      monthlyPayIfBought: rentBuyAnalyzerData.monthlyPayIfBought || 0,
      propertytax: rentBuyAnalyzerData.propertytax || 0,
      interestrate: rentBuyAnalyzerData.interestrate || 0.001,
      monthlyRent: rentBuyAnalyzerData.monthlyRent || 0,
      downpayment: rentBuyAnalyzerData.downpayment || 0,
      annualIncreaseInHomePerc: rentBuyAnalyzerData.annualIncreaseInHomePerc || 0,
      yearsOfComparison: rentBuyAnalyzerData.yearsOfComparison || 5
    });
    let outdata = ref("");
    const resetResults = () => {
      outdata.value = "";
    };
    const errorMonthlyPayIfBought = computed(() => {
      return isValidItem(indata.monthlyPayIfBought, 0, 100000000, formatMoneyValueLong);
    });
    const errorRate = computed(() => {
      return isValidItem(indata.interestrate, 0.001, 100, formatVal);
    });
    const errorPropertytax = computed(() => {
      return isValidItem(indata.propertytax, 300, 10000, formatMoneyValueLong);
    });
    const errorMonthlyRent = computed(() => {
      return isValidItem(indata.monthlyRent, 0, 100000000, formatMoneyValueLong);
    });
    const errorDownpayment = computed(() => {
      return isValidItem(indata.downpayment, 2000, 1000000, formatMoneyValueLong);
    });
    const errorAnnualIncreaseInHomePerc = computed(() => {
      return isValidItem(indata.annualIncreaseInHomePerc, 0.001, 100, formatVal);
    });
    const errorYearsOfComparison = computed(() => {
      return isValidItem(indata.yearsOfComparison, 1, 35, formatIntegerQuantity);
    });
    const erMsgs = {
      errorMonthlyPayIfBought,
      errorRate,
      errorPropertytax,
      errorMonthlyRent,
      errorDownpayment,
      errorAnnualIncreaseInHomePerc,
      errorYearsOfComparison
    };
    function formatMoney(val) {
      return val && val > 0 ? formatMoneyValueLong(val) : "-";
    }
    function handleCalc() {
      let hasError = false;
      for (const m of _Object$values(erMsgs)) {
        if (m.value !== "") {
          showToast("error", m.value);
          hasError = true;
        }
      }
      if (hasError) {
        resetResults();
        return;
      }
      const inputs = {};
      const inputKeys = _Object$keys(indata);
      inputKeys.forEach(function (key) {
        const v = Number(indata[key].toString());
        if (_Number$isFinite(v)) inputs[key] = v;else {
          inputs[key] = 0;
        }
      });
      const interestrate = inputs.interestrate / 100.0;
      const downpayment = inputs.downpayment;
      const propertytax = inputs.propertytax;
      const annualIncreaseInHomePerc = inputs.annualIncreaseInHomePerc / 100.0;
      const monthlyPayIfBought = inputs.monthlyPayIfBought;
      const monthlyRent = inputs.monthlyRent;
      const yearsOfComparison = inputs.yearsOfComparison;
      const compound = 2 / 12;
      const monTime = 25 * 12;
      const yrRate = interestrate / 2;
      const rdefine = Math.pow(1.0 + yrRate, compound) - 1.0;
      const purchcompound = Math.pow(1.0 + rdefine, monTime);
      const netMonthlyPayment = monthlyPayIfBought - propertytax / 12;
      const presentValueOfMortgage = (0 + netMonthlyPayment * (purchcompound - 1.0) / rdefine) / purchcompound;
      const totalInitialInvestment = downpayment + presentValueOfMortgage;
      const futureMortgageBalance = presentValueOfMortgage * Math.pow(1.0 + rdefine, 12 * yearsOfComparison) - netMonthlyPayment * (Math.pow(1.0 + rdefine, 12 * yearsOfComparison) - 1.0) / rdefine;
      const principalPaid = presentValueOfMortgage - futureMortgageBalance;
      const homeAppreciationGain = totalInitialInvestment * (Math.pow(1 + annualIncreaseInHomePerc, yearsOfComparison) - 1);
      const monthlySavingsVsRent = monthlyPayIfBought - monthlyRent;
      const monthlyRate = 0.04 / 12;
      const mthsOfComparison = yearsOfComparison * 12;
      const investmentReturnIfRented = downpayment * (Math.pow(1.04, yearsOfComparison) - 1) + monthlySavingsVsRent * (Math.pow(1 + monthlyRate, mthsOfComparison) - 1) / monthlyRate;
      const totalOwnerNetGain = principalPaid + homeAppreciationGain;
      let buyOrRent;
      let greatOrLess;
      if (totalOwnerNetGain > investmentReturnIfRented) {
        buyOrRent = i18n.t("financial-tools.Buy");
        greatOrLess = i18n.t("financial-tools.greater");
      } else {
        buyOrRent = i18n.t("financial-tools.ContinuetoRent");
        greatOrLess = i18n.t("financial-tools.less");
      }
      outdata.value = i18n.t("financial-tools.YouShouldDecide", {
        buyOrRent,
        greatOrLess,
        yearsOfComparison,
        downpayment: formatMoneyValueLong(downpayment),
        netMonthlyPayment: formatMoneyValueLong(netMonthlyPayment),
        totalInitialInvestment: formatMoneyValueLong(totalInitialInvestment),
        presentValueOfMortgage: formatMoneyValueLong(presentValueOfMortgage),
        principalPaid: formatMoneyValueLong(principalPaid),
        monthlyPayIfBought: formatMoneyValueLong(monthlyPayIfBought),
        homeAppreciationGain: formatMoneyValueLong(homeAppreciationGain),
        totalOwnerNetGain: formatMoneyValueLong(totalOwnerNetGain),
        investmentReturnIfRented: formatMoneyValueLong(investmentReturnIfRented),
        monthlySavingsVsRent: formatMoneyValueLong(monthlySavingsVsRent)
      }).toString();
      return outdata;
    }
    onMounted(() => {
      $("[name='monthlyPayIfBought']").trigger("focus");
    });
    onUnmounted(() => {
      localStorage.setItem(componentName, _JSON$stringify(indata));
    });
    const isLoading = ref(false);
    return {
      indata,
      outdata,
      erMsgs,
      formatMoney,
      resetResults,
      handleClearSelection,
      handleCalc,
      isLoading
    };
  }
});